import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { RequestsComponent } from "./requests/requests.component";
import { RequestDetailsComponent } from "./request-details/request-details.component";
import { RequestAddComponent } from "./request-add/request-add.component";
import { RequestUpdateComponent } from "./request-update/request-update.component";


export const REQUEST_ROUTES: Routes = [
  {
    path: 'components',
    pathMatch: 'full',
    redirectTo: 'requests/overview'

  },
  {
    path: 'requests/overview',
    component: RequestsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'request/details/:prid/:reqid',
    component: RequestDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'request/add/:prid',
    component: RequestAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'request/update/:prid/:reqid',
    component: RequestUpdateComponent,
    canActivate: [authGuard]
  }
]
